import React from 'react';

export const Button = ({ 
  type = 'button', 
  variant = 'default', 
  onClick, 
  children, 
  className = '',
  disabled = false
}) => {
  const variantClasses = {
    default: 'btn-primary',
    outline: 'btn-outline',
    secondary: 'btn-secondary',
    terziaer: 'btn-terziaer'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn ${variantClasses[variant]} ${className}`}
    >
      {children}
    </button>
  );
};
